<template>
   
    <div class="card-health">
         <div>中医体检健康卡</div>
<!-- 中医体检健康卡 -->
        <div class="card-box">
            <div class="card-title">手机扫一扫，开始中医体检</div>
            <div class="two-dimension">图片
                <img src="" alt="">
            </div>
        </div>

        <div class="Fair-Detail">
            <div class="fair-title">
                <p>活动介绍</p>
                <div class="fair-content">
                    <span> &nbsp; &nbsp; &nbsp; &nbsp;力菲健康管理通过权威、专业、准确的各项体检项目，极力打造中、高端健康人群“健康管理一站式服务”，做到：不仅仅是能让您获得健康身体，更能让您从此走进一种绿色的健康生活方式。</span>
                    <br>
                    <span>  &nbsp; &nbsp; &nbsp; &nbsp;力菲健康管理通过权威、专业、准确的各项体检项目，极力打造中、高端健康人群“健康管理一站式服务”，做到：不仅仅是能让您获得健康身体，更能让您从此走进一种绿色的健康生活方式。</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

<style lang="less" scoped>
.card-health{
    padding: 0 0.32rem;
    background-size: 100%;
    min-height: 100%;
    background-color: #7ee68c;
    padding-top: 0.79rem;
    box-sizing:border-box;
}
.card-box{
    width: 100%;
    height: 6rem;
    background-color: rgb(255,255,255);
    border-radius: 0.2rem;
    margin-bottom: 0.33rem;
}
.card-title{
    text-align: center;
    padding-top: 0.73rem;
    font-size: 0.34rem;
    color: rgb(51,51,51);
    font-weight:bold;
    padding-bottom: 0.25rem;
    
}
.two-dimension{
    width: 4.29rem;
    height: 4.04rem;
    background-color: pink;
    margin: 0 auto;
    
}
.Fair-Detail{
    width: 100%;
    height: 4.94rem;
    background-color: rgb(255,255,255);
    border-radius: 0.2rem;
    box-sizing:border-box;  
}
.fair-title{
    width: 100%;
    height: 0.92rem;
    border-bottom:0.01rem solid rgb(238,238,238);
    p{
        line-height: 0.92rem;
        padding-left: 0.19rem;
        font-size: 0.3rem;
        color: rgb(51,51,51);
    }
}
.fair-content{
    span{
        font-size: 0.26rem;
        color: rgb(51,51,51);
    }
}
</style>
